angular.module('backstage.controllers.participants', []);

require('./PaxTableCtrl');
